function iteratorFromEntries(entries) {
  var index = 0;

  return {
    next: function() {
      if (index >= entries.length) return { done: true };

      var value = entries[index];
      index += 1;
      return { value: value, done: false };
    },
    [Symbol.iterator]: function() {
      return this;
    }
  };
}

function entriesFromForEach(searchParams) {
  var entries = [];
  searchParams.forEach(function(value, name) {
    entries.push([name, value]);
  });
  return iteratorFromEntries(entries);
}

if (
  typeof Symbol !== "undefined" &&
  Symbol.iterator &&
  typeof URLSearchParams !== "undefined" &&
  URLSearchParams.prototype
) {
  var prototype = URLSearchParams.prototype;

  if (typeof prototype.entries !== "function" && typeof prototype.forEach === "function") {
    Object.defineProperty(prototype, "entries", {
      configurable: true,
      writable: true,
      value: function() {
        return entriesFromForEach(this);
      }
    });
  }

  if (typeof prototype[Symbol.iterator] !== "function" && typeof prototype.entries === "function") {
    Object.defineProperty(prototype, Symbol.iterator, {
      configurable: true,
      writable: true,
      value: prototype.entries
    });
  }
}
